/**
 * Util for metrics and RPM.
 */
import i18n from "@/providers/i18n"
import * as _ from 'lodash'


export default {
    /**
     * These need to be functions since translations may not be loaded when Metric.js gets imported
     */
    checkStatusLabels() {
        return {
            NOMINAL: {label: i18n.gt('LABEL_RPM_CHECK_NOMINAL'), variant: 'success'},
            OUT_OF_RANGE: {label: i18n.gt('LABEL_RPM_CHECK_OUT_OF_RANGE'), variant: 'warning'},
            NEEDS_ATTENTION: {label: i18n.gt('LABEL_RPM_CHECK_NEEDS_ATTENTION'), variant: 'danger'},
            NO_DATA: {label: i18n.gt('LABEL_RPM_CHECK_NO_DATA'), variant: 'secondary'},
        }
    },
    metricLabels() {
        return {
            WEIGHT: i18n.gt('LABEL_METRICS_WEIGHT'),
            ACTIVITY: i18n.gt('LABEL_METRICS_ACTIVITY'),
            HEARTRATE: i18n.gt('LABEL_METRICS_HEARTRATE'),
            HRV: i18n.gt('LABEL_METRICS_HRV'),
            BLOOD_PRESSURE: i18n.gt('LABEL_METRICS_BLOOD_PRESSURE'),
            SPO2: i18n.gt('LABEL_METRICS_SPO2'),
            SLEEP: i18n.gt('LABEL_METRICS_SLEEP'),
        }
    },
    unitLabels() {
        return {
            WEIGHT: i18n.gt('LABEL_METRICS_WEIGHT_UNITS'),
            ACTIVITY: i18n.gt('LABEL_METRICS_ACTIVITY_UNITS'),
            HEARTRATE: i18n.gt('LABEL_METRICS_HEARTRATE_UNITS'),
            HRV: i18n.gt('LABEL_METRICS_HRV_UNITS'),
            BLOOD_PRESSURE: i18n.gt('LABEL_METRICS_BLOOD_PRESSURE_UNITS'),
            SPO2: i18n.gt('LABEL_METRICS_SPO2_UNITS'),
            SLEEP: i18n.gt('LABEL_METRICS_SLEEP_UNITS'),
        }
    },
    /**
     * Returns an ordered list of the available metrics e.g. ACTIVITY, STEPS, BLOOD_PRESSURE etc..
     * given a participant.metrics object. Only metrics with readings will be returned.
     */
    availableMetrics(metrics) {
        console.log('Metrics:availableMetrics  metrics=', metrics)
        let metricsWithReadings = _.filter(metrics, met => met.readings.length > 0 )

        //The order of this array determines the order of the charts on MyLogs
        let orderedMetrics = [
            'ACTIVITY',
            'WEIGHT',
            'HEARTRATE',
            'HRV',
            'BLOOD_PRESSURE',
            'SPO2',
            'SLEEP'
        ]

        let availableMetrics = []
        orderedMetrics.forEach((metric) => {
            let hasMet = metricsWithReadings.find((m) => {
                //We will include BLOOD_PRESSURE if we find a SYSTOLIC or DIASTOLIC metric
               return m.metric === metric ||
                   ((m.metric === 'SYSTOLIC' || m.metric === 'DIASTOLIC') && metric === 'BLOOD_PRESSURE')
            })
           if(hasMet) {
               availableMetrics.push(metric)
           }
        })

        console.log('Metrics:availableMetrics  availableMetrics=', availableMetrics)
        return availableMetrics
    },
    /**
     * Returns entries for a particular service given a participant.metrics object.
     *
     * An 'Entries' object is formatted:
     * { ACTIVITY : ['2020-11-14' : 4500, '2020-12-14' : 3900]}
     * which is the format expected by Api.postMetricManualEntry
     */
    metricsToEntries(metrics, service) {
        let entries = {}
        _.forEach(metrics, (metric) => {
            if (metric.service == service) {
                entries[metric.metric] = {}

                _.forEach(metric.readings, (reading) => {
                    entries[metric.metric][reading.value.dateTime] = reading.value.value
                })
            }
        })
        return entries
    }

}
